import { login as loginApi } from '@/api/auth'
import { getToken, setToken, removeToken, getUserInfo, setUserInfo, removeUserInfo } from '@/utils/auth'

const state = {
  token: getToken() || '',
  userInfo: getUserInfo() || null
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  },
  CLEAR_AUTH(state) {
    state.token = ''
    state.userInfo = null
  }
}

const actions = {
  async login({ commit, dispatch }, form) {
    if (!form.username || !form.password) {
      throw new Error('请输入账号和密码')
    }

    // 与 waiqinfengweb 一致：account + password
    const res = await loginApi({
      account: form.username,
      password: form.password
    })

    // 返回结构：{ code: 1, data: { userinfo: { token, nickname, avatar, ... } } }
    const userinfo = (res.data && res.data.userinfo) || res.data || {}
    const token = userinfo.token || ''

    if (!token) {
      throw new Error(res.msg || '登录失败：未返回 token')
    }

    const userInfo = {
      id: userinfo.id || userinfo.user_id || '',
      name: userinfo.nickname || userinfo.username || form.username,
      nickname: userinfo.nickname || form.username,
      role: userinfo.role || '',
      avatar: userinfo.avatar || '',
      ...userinfo
    }

    commit('SET_TOKEN', token)
    commit('SET_USER_INFO', userInfo)
    setToken(token)
    setUserInfo(userInfo)
    // 登录后建立全局 WebSocket
    dispatch('websocket/connectAppWebSocket', {}, { root: true }).catch(() => {})
    return { token, userInfo }
  },

  logout({ commit, dispatch }) {
    dispatch('websocket/closeWebSocket', null, { root: true })
    commit('CLEAR_AUTH')
    removeToken()
    removeUserInfo()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
